import { Outlet, useParams } from "react-router";
import { useAppDispatch, useAppSelector } from "../../../hooks/app";
import { useEffect, useState } from "react";
import { StatusEnum } from "../../../commons/enums/status-enum";
import { AppBox, AppContainer, AppModal, NotFound } from "../../../commons/components";
import TeamManageDetailHeader from "./components/TeamManageDetailHeader";
import TeamAddEdit from "./components/teamAddEdit/TeamAddEdit";
import { cleanUpManageTeamInfo, fetchManageTeam } from "../../../redux/slices/football/admin/team/manage-team-slice";
import { setPageTitle } from "../../../redux/slices/page-title-slice";
import setDocumentTitle from "../../../commons/utilities/document-title";
import { cleanUpManageTeamCompetitions } from "../../../redux/slices/football/admin/team/manage-team-competitions-slice";
import IconEdit from "../../../commons/components/icons/edit";
import { cleanUpStepperFormData } from "../../../redux/slices/stepper-form-slice";
import { cleanUpFetchedTeamData } from "../../../redux/slices/football/fetched-team-slice";
import { cleanUpManageStanding } from "../../../redux/slices/football/admin/competition/manage-competition-season-standing-slice";

export default function TeamDetailManage() {
  const { teamId } = useParams();
  const dispatch = useAppDispatch();
  const [isEditTeam, setIsEditTeam] = useState(false);
  const { teamInfo, teamInfoStatus } = useAppSelector((state) => state.footballManageTeam);
  const { teamEditResponseStatus } = useAppSelector((state) => state.footballManageTeamEdit);
  useEffect(() => {
    dispatch(fetchManageTeam(Number(teamId)));
  }, [teamId]);

  useEffect(() => {
    if (teamInfoStatus === StatusEnum.Failed) {
      return () => {
        dispatch(cleanUpManageTeamInfo());
        dispatch(cleanUpManageTeamCompetitions());
      };
    }
  }, [teamInfoStatus]);

  useEffect(() => {
    dispatch(setPageTitle(""));
    return () => {
      dispatch(cleanUpManageTeamInfo());
      dispatch(cleanUpFetchedTeamData());
      dispatch(cleanUpManageTeamCompetitions());
      dispatch(cleanUpManageStanding());
    };
  }, []);

  useEffect(() => {
    setDocumentTitle([`${teamInfo.shortName}`, "Manage"]);
  }, [teamInfo]);

  const handleAfterEdit = () => {
    setIsEditTeam(false);
    dispatch(fetchManageTeam(Number(teamId)));
  };

  const handleAfterEditClose = () => {
    setIsEditTeam(false);
    dispatch(cleanUpStepperFormData());
  };

  return (
    <AppContainer>
      {teamInfoStatus === StatusEnum.Failed ? (
        <NotFound />
      ) : (
        <AppBox mt="md" flexDirection="column" gap="md">
          <TeamManageDetailHeader team={teamInfo} onEditTeam={() => setIsEditTeam(true)} />
          <Outlet />
        </AppBox>
      )}
      <AppModal
        opened={isEditTeam}
        modalSize="lg"
        onClose={handleAfterEditClose}
        title="Edit Team"
        titleIcon={<IconEdit />}
        withLoadingButton={teamEditResponseStatus === StatusEnum.Loading}
        withoutButtons
      >
        <TeamAddEdit teamData={teamInfo} onCancel={handleAfterEditClose} onSave={handleAfterEdit} />
      </AppModal>
    </AppContainer>
  );
}
